import { WebPlugin } from "@capacitor/core";
export class HomeIndicatorWeb extends WebPlugin {
    async hide() {
        this.unimplemented("Not implemented on web.");
        console.log("hide");
    }
    async show() {
        this.unimplemented("Not implemented on web.");
        console.log("show");
    }
    async isHidden() {
        this.unimplemented("Not implemented on web.");
        console.log("getStatus");
        return { hidden: true };
    }
    async getPluginVersion() {
        console.warn("Cannot get plugin version in web");
        return { version: "default" };
    }
}
//# sourceMappingURL=web.js.map